module.exports = "/assets/data/3ed86c09c415b0bb3e8b7bbebd3ab05f-WA9.data.json";